module.exports = __webpack_public_path__ + "static/media/apester-logo-shape.05b4a4ff.svg";